import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar, Menu, MenuItem, menuClasses } from 'react-pro-sidebar';
import {
    PlayArrow as FireIcon,
    Visibility as HologramIcon,
    BugReport as DefectIcon,
    Verified as CertificateIcon,
    ExitToApp as ExitIcon
} from '@mui/icons-material';
import { Link, Route, Routes } from 'react-router-dom';
import Info from './layout/Info2';
import SubmitBatteryData from './layout/SubmitBatteryData';
import CellHealthHologram from './layout/CellHealthHologram';
import DefectAnalysis from './layout/DefectAnalysis';
import CellHealthCertificate from './layout/CellHealthCertificate2';
import './BatteryScopeV2C.css';
import logo from "../../assets/img/logos/logo-no-background.png";
import logoicon from "../../assets/Tab_Icon.png";
import IconButton from '@mui/material/IconButton';
import { Menu as MenuIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const themes = {
    light: {
        sidebar: {
            backgroundColor: '#ffffff',
            color: '#607489',
        },
        menu: {
            menuContent: '#fbfcfd',
            icon: '#FFA500',
            hover: {
                backgroundColor: '#c5e4ff',
                color: '#44596e',
            },
            disabled: {
                color: '#9fb6cf',
            },
        },
        header: {
            backgroundColor: '#000000',
            color: '#000000',
        },
    },
    dark: {
        sidebar: {
            backgroundColor: '#000000',
            color: '#ffffff',
        },
        menu: {
            menuContent: '#082440',
            icon: '#FFA500',
            hover: {
                backgroundColor: '#00458b',
                color: '#b6c8d9',
            },
            disabled: {
                color: '#3e5e7e',
            },
        },
        header: {
            backgroundColor: '#000000',
            color: '#ffffff',
        },
    },
};

const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const StyledMenuItem = styled(MenuItem)({
    fontWeight: "500",
    fontSize: "14px",
    fontFamily: '"Bai Jamjuree", sans-serif',
});

const pages = [
    "/batteryscope-c",
    "/batteryscope-c/visualize",
    "/batteryscope-c/defect-analysis",
    "/batteryscope-c/cell-health-certificate",
];

const visitedPages = [];
const isPageActive = (pathname, page) => {
    if(visitedPages.includes(page)){
        return true;
    }
    return pages.indexOf(pathname) >= pages.indexOf(page);
};

const isCurrentPage = (pathname, page) => {
    return pathname === page;
};


const BatteryScopeV2C = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [toggled, setToggled] = useState(false);
    const [rtl, setRtl] = useState(false);
    const [hasImage, setHasImage] = useState(true);
    const [theme, setTheme] = useState('dark');
    const [dataSubmitted, setDataSubmitted] = useState(null);
    const [csvData, setCsvData] = useState(null);
    const { pathname } = useLocation();

    const menuItemStyles = {
        root: {
            fontSize: '13px',
            fontWeight: 400,
            fontFamily: "'Bai Jamjuree', sans-serif",
        },
        icon: {
            color: themes[theme].menu.icon,
            [`&.${menuClasses.disabled}`]: {
                color: themes[theme].menu.disabled.color,
            },
        },
        SubMenuExpandIcon: {
            color: '#b6b7b9',
        },
        subMenuContent: ({ level }) => ({
            backgroundColor:
                level === 0
                    ? hexToRgba(themes[theme].menu.menuContent, hasImage && !collapsed ? 0.4 : 1)
                    : 'transparent',
            fontFamily: "'Bai Jamjuree', sans-serif",
        }),
        button: {
            [`&.${menuClasses.disabled}`]: {
                color: themes[theme].menu.disabled.color,
            },
            '&:hover': {
                backgroundColor: hexToRgba(themes[theme].menu.hover.backgroundColor, hasImage ? 0.8 : 1),
                color: themes[theme].menu.hover.color,
            },
            '&.active': {
                backgroundColor: '#e8442d',
                color: '#ffffff',
                fontWeight: 600,
                borderRadius: '8px',
                margin: '4px 8px',
                boxShadow: '0 4px 8px rgba(232, 68, 45, 0.3)',
                '& .pro-icon-wrapper': {
                    color: '#ffffff !important',
                },
            },
            fontFamily: "'Bai Jamjuree', sans-serif",
        },
        label: ({ open }) => ({
            fontWeight: open ? 600 : undefined,
            fontFamily: "'Bai Jamjuree', sans-serif",
        }),
    };

    useEffect(() => {
        if(pathname){
            visitedPages.push(pathname);
        }
    }, [pathname]); 

    const handleThemeChange = () => {
        setTheme(theme === 'dark' ? 'light' : 'dark');
    };

    return (
        <div style={{ display: 'flex', height: '100vh', flexDirection: 'column', direction: rtl ? 'rtl' : 'ltr' }}>
            {/* <Nav /> */}

            <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                <Sidebar
                    collapsed={collapsed}
                    toggled={toggled}
                    onBackdropClick={() => setToggled(false)}
                    onBreakPoint={() => setToggled(!toggled)}
                    // image={hasImage ? "https://user-images.githubusercontent.com/25878302/144499035-2911184c-76d3-4611-86e7-bc4e8ff84ff5.jpg" : undefined}
                    rtl={rtl}
                    breakPoint="md"
                    backgroundColor={hexToRgba(themes[theme].sidebar.backgroundColor, hasImage ? 1 : 1)}
                    rootStyles={{
                        color: themes[theme].sidebar.color,
                        fontFamily: 'Bai Jamjuree',
                    }}
                >
                    <div style={{ textAlign: 'center', margin: '20px 20px', padding: '10px 0px' }} onClick={() => window.location.replace('/batteryscope-c')}>
                        {collapsed ? <img src={logoicon} alt="Logo" style={{ width: '100%', height: 'auto' }} /> : <img src={logo} alt="Logo" style={{ width: '100%', height: 'auto' }} />}
                    </div>
                    <Menu menuItemStyles={menuItemStyles}>
                        {/* <StyledMenuItem 
                                icon={<FireIcon />} 
                                component={<Link to="submit" />} 
                                className={isPageActive(pathname, '/batteryscope-c/submit') ? 'active' : ''}
                                disabled={!isPageActive(pathname, '/batteryscope-c/submit')}
                            >
                                Fire BatteryScope-C
                        </StyledMenuItem> */}
                        <StyledMenuItem 
                            icon={<FireIcon />} 
                            component={<Link to="/batteryscope-c" />} 
                            disabled={!isPageActive(pathname, '/batteryscope-c')}
                            style={isCurrentPage(pathname, '/batteryscope-c') ? {
                                backgroundColor: 'rgba(232, 68, 45, 0.15)',
                                color: '#e8442d',
                                fontWeight: 600,
                                borderLeft: '4px solid #e8442d',
                                margin: '2px 0',
                            } : {}}
                        >
                            Capture Battery Data
                        </StyledMenuItem>
                        <StyledMenuItem 
                            icon={<HologramIcon />} 
                            component={<Link to="visualize" />} 
                            disabled={!isPageActive(pathname, '/batteryscope-c/visualize')}
                            style={isCurrentPage(pathname, '/batteryscope-c/visualize') ? {
                                backgroundColor: 'rgba(232, 68, 45, 0.15)',
                                color: '#e8442d',
                                fontWeight: 600,
                                borderLeft: '4px solid #e8442d',
                                margin: '2px 0',
                            } : {}}
                        >
                            Cell Health Holograms
                        </StyledMenuItem>
                        <StyledMenuItem 
                            icon={<DefectIcon />} 
                            component={<Link to="defect-analysis" />} 
                            disabled={!isPageActive(pathname, '/batteryscope-c/defect-analysis')}
                            style={isCurrentPage(pathname, '/batteryscope-c/defect-analysis') ? {
                                backgroundColor: 'rgba(232, 68, 45, 0.15)',
                                color: '#e8442d',
                                fontWeight: 600,
                                borderLeft: '4px solid #e8442d',
                                margin: '2px 0',
                            } : {}}
                        >
                            Defect Analytics
                        </StyledMenuItem>
                        <StyledMenuItem 
                            icon={<CertificateIcon />} 
                            component={<Link to="cell-health-certificate" />} 
                            disabled={!isPageActive(pathname, '/batteryscope-c/cell-health-certificate')}
                            style={isCurrentPage(pathname, '/batteryscope-c/cell-health-certificate') ? {
                                backgroundColor: 'rgba(232, 68, 45, 0.15)',
                                color: '#e8442d',
                                fontWeight: 600,
                                borderLeft: '4px solid #e8442d',
                                margin: '2px 0',
                            } : {}}
                        >
                            Cell Health Certificates
                        </StyledMenuItem>
                    </Menu>
                </Sidebar>
                <div style={{ flex: 1, padding: 20, overflow: 'hidden', backgroundColor: themes[theme].sidebar.backgroundColor }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', borderBottom: '1px solid #dedede', paddingBottom: '15px' }}>
                        <IconButton onClick={() => setCollapsed(!collapsed)} style={{ color: themes[theme].header.color }}>
                            <MenuIcon />
                        </IconButton>
                        <h1 className="text-xl text-[#e8442d] text-center md:text-2xl lg:text-2xl">
                            BatteryScope-C: Cell Quality Assurance
                        </h1>
                        <div style={{ display: 'flex' }}>
                            <IconButton style={{ color: themes[theme].header.color }} onClick={() => window.location.replace('/')}>
                                <ExitIcon />
                            </IconButton>
                        </div>
                    </div>
                    <Routes>
                        <Route path="submit" element={<SubmitBatteryData setDataSubmitted={setDataSubmitted} csvData={csvData} setCsvData={setCsvData} />} />
                        <Route path="visualize" element={<CellHealthHologram dataSubmitted={dataSubmitted} csvData={csvData} />} />
                        <Route path="defect-analysis" element={<DefectAnalysis />} />
                        <Route path="cell-health-certificate" element={<CellHealthCertificate />} />
                        <Route path="/" element={<Info />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
};

export default BatteryScopeV2C;
